import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Main layout wrapper for the interview booking application
 * Provides consistent header and footer across all pages
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="py-8 px-4">
        {children}
      </main>
      <div className="mt-auto">
        <Footer />
      </div>
    </div>
  );
}
